// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"0d2a03c0","231":"e164dd32","761":"0e1dc99a"}[chunkId] + ".chunk.js";
};